'use client';

import { cn } from '@coas/ui/lib';
import { useAtom } from 'jotai';
import { api } from 'trpc/react';
import type { PropsOf } from '~/shared/lib';
import { categoryStateAtom } from '../model/state';
import { CategoryLink, CategoryLinkSkeleton } from './CategoryLink';

type CategoriesProps = PropsOf<'nav'>;

export const Categories = ({ className, ...props }: CategoriesProps) => {
    const [{ sex }] = useAtom(categoryStateAtom);

    const { isLoading, isSuccess, data } = api.category.getAll.useQuery([sex]);

    return (
        <nav
            {...props}
            className={cn('hidden h-full items-stretch justify-center bg-neutral-600 font-futura md:flex', className)}
        >
            {isLoading &&
                Array.from({ length: 8 }).map((_, index) => <CategoryLinkSkeleton key={index} index={index} />)}
            {isSuccess && data.items.map(category => <CategoryLink key={category.id} category={category} />)}
        </nav>
    );
};
